<template>
  <div class="form-group">
    <div class="card-label">
      <img class="lock" src="@/assets/static/img/lock.png" alt="..."/>
      <label v-if="label" class="control-label">
        {{label}}
      </label>
    </div>
    <div id="card-element">
    <!-- A Stripe Element will be inserted here. -->
    </div>

    <!-- Used to display form errors. -->
    <div id="card-errors" role="alert"></div>
  </div>
</template>

<script>
  // Create a Stripe client.
  var stripe = Stripe('pk_live_KbEau8qXfNI28Fleob2Fee1J');

  export default {
    props: {
      submitting_billing_info: Boolean,
    },
    data: function () {
      return {
        card: null,
        label: "Credit or debit card",
      }
    },
    methods: {
      createStripeToken () {
        const self = this
        stripe.createToken(this.card).then(function(result) {
          if (result.error) {
            // Inform the user if there was an error.
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
            self.$emit('errorHandler');
          } else {
            // Handle newly created token
            self.$emit('stripeTokenHandler', result.token.id);
          }
        });
      },
    },
    watch: {
      submitting_billing_info: function (val) {
        if (val) {
          this.createStripeToken()
        }
      },
    },
    mounted: function () {
      // Create an instance of Elements.
      var elements = stripe.elements();

      // Custom styling can be passed to options when creating an Element.
      var style = {
        base: {
          color: '#32325d',
          lineHeight: '15px',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '15px',

          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      // Create an instance of the card Element.
      var card = elements.create('card', {style: style});

      this.card = card

      // Add an instance of the card Element into the `card-element` <div>.
      card.mount('#card-element');

      // Handle real-time validation errors from the card Element.
      card.addEventListener('change', function(event) {
        var displayError = document.getElementById('card-errors');
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = '';
        }
      });
    }
  }
</script>
